import { axios } from '@/services/axios';

const getTCAPUsers = async (currentCompany) => {
    const res = await axios.get(`/TCAPUsers/${currentCompany}`);

    return res.data;
};

export default getTCAPUsers;
